import type { QboTransactionSearchRow } from '@/services/qboTransactionSearch'

/** Unique QBO URLs from selected rows, stable by first `transaction_id` appearance. */
export function uniqueQboUrlsFromSelectedRows(rows: QboTransactionSearchRow[]): string[] {
  const urlsByTxnId = new Map<string, string>()
  const order: string[] = []

  for (const row of rows) {
    const txnId = row.transaction_id?.trim()
    if (!txnId) continue

    const url = row.url?.trim() ?? ''
    if (!urlsByTxnId.has(txnId)) {
      urlsByTxnId.set(txnId, url)
      order.push(txnId)
    } else if (!urlsByTxnId.get(txnId) && url) {
      urlsByTxnId.set(txnId, url)
    }
  }

  return order
    .map((txnId) => urlsByTxnId.get(txnId) ?? '')
    .filter((url) => url.length > 0)
}

export type OpenQboUrlsResult = {
  opened: number
  blocked: number
}

export function openQboUrls(
  urls: string[],
  openFn: (url: string) => Window | null = (url) =>
    window.open(url, '_blank', 'noopener,noreferrer')
): OpenQboUrlsResult {
  let opened = 0
  let blocked = 0
  for (const url of urls) {
    const win = openFn(url)
    if (win === null) blocked += 1
    else opened += 1
  }
  return { opened, blocked }
}
